export type ChatPlatform = 'whatsapp' | 'instagram';

export type MessageType =
    | 'text'
    | 'image'
    | 'audio'
    | 'video'
    | 'document'
    | 'sticker'
    | 'location'
    | 'contact'
    | 'pix'
    | 'poll'
    | 'system';

/** Rótulos de mensagem apagada — fonte única para UI e persistência */
export const CHAT_DELETED_LABEL = 'Mensagem apagada';
export const CHAT_DELETING_LABEL = 'Apagando mensagem...';

export interface MediaContent {
    url: string;
    mimetype?: string;
    filename?: string;
    caption?: string;
    thumbnail?: string;
    duration?: number;
    size?: number;
    /** Transcrição do áudio (speechToText) */
    transcription?: string | null;
}

/** Dados da mensagem sendo respondida */
export interface QuotedMessage {
    id: string;
    content?: string;
    type: MessageType;
    sender: 'me' | 'them';
    mediaUrl?: string;
}

/** Reação (emoji) em uma mensagem */
export interface MessageReaction {
    emoji: string;
    sender: 'me' | 'them';
    timestamp?: string;
}

/** Dados do criativo do anúncio Meta Ads para renderizar card no chat */
export interface AdMetadata {
    imageUrl?: string;
    headline?: string;
    body?: string;
    sourceUrl?: string;
    sourceId?: string;
    mediaType?: string;
    ctaTitle?: string;
}

export interface ChatMessage {
    id: string;
    /** Correlação exata do envio local com a outbox, sem comparar conteúdo. */
    clientMessageId?: string;
    type: MessageType;
    text?: string;
    media?: MediaContent;
    sender: 'me' | 'them' | 'system';
    timestamp: Date;
    status: 'pending' | 'uncertain' | 'sent' | 'delivered' | 'read' | 'failed';
    /** Mensagem original sendo respondida, se houver */
    quotedMessage?: QuotedMessage;
    /** Reações (emojis) na mensagem */
    reactions?: MessageReaction[];
    /** Indica se a mensagem foi editada */
    is_edited?: boolean;
    /** Dados do anúncio Meta Ads (quando msg veio de CTWA) */
    adMetadata?: AdMetadata;
    /** Responsável CRM (ex.: follow-up com assigned_to) */
    sentBy?: { id: string; full_name: string };
}

export interface ChatConversation {
    id: string;
    name: string;
    avatar?: string;
    lastMessage?: string;
    lastMessageTime?: Date;
    unreadCount: number;
    messages: ChatMessage[];
    assignedTo?: string;
    tags?: string[];
    status?: 'active' | 'closed';
    stageName?: string;
    /** ID do contato relacionado à conversa */
    contactId?: string;
    /** Nome da instância do WhatsApp usada na conexão */
    instanceName?: string;
    /** Dados de atribuição do Meta Ads (quando veio de anúncio CTWA) */
    metaAttribution?: MetaAttribution;
    /** Canal de mensagens */
    platform?: ChatPlatform;
    /** ID da integração (connection_id) */
    connectionId?: string;
}

/** Dados de atribuição do Meta Ads para conversas originadas de anúncios */
export interface MetaAttribution {
    ctwaClid?: string;
    sourceId?: string;
    campaignId?: string;
    campaignName?: string;
    adsetId?: string;
    adsetName?: string;
    adId?: string;
    adName?: string;
    headline?: string;
    capturedAt?: string;
    googleClickId?: string;
    keyword?: string;
    igSid?: string;
    instagramBusinessAccountId?: string;
    /** Username Instagram do contato (sem @) */
    instagramUsername?: string;
    messagingChannel?: 'whatsapp' | 'instagram';
    origin?: string;
}

/** Referência mínima ao citar mensagem no envio (texto / reply). */
export type SendQuotedRef = { id: string; sender: string; text?: string };

